import React from 'react';
import { connect } from 'react-redux';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import PropTypes from 'prop-types';
// Core components
import Tooltip from 'components/core/Tooltip';
// Models
import mBooking from 'models/cpm/booking';
// Custom
import { cpmBookingDataShape } from 'constants/PropTypesShapes';
import AppIcon from 'components/icons/AppIcon';
import WarningIcon from 'components/misc/WarningIcon';
import BookingTooltipContent from './BookingTooltipContent';

const BookingStatusInfoIcon = ({
  booking,
  timezone,
  withInfoTooltip,
}) => {
  // Get booking status
  const {
    icon,
    color,
    value: bookingStatus,
  } = mBooking.bookingStatus(booking);

  const entryAndExitForbidden = booking.restrictedByForbiddenEntry && booking.restrictedByForbiddenExit;

  /* ========================================================= */
  /* SUB COMPONENTS                                            */
  /* ========================================================= */

  const TooltipContent = withInfoTooltip
    ? (
      <BookingTooltipContent
        booking={booking}
        timezone={timezone}
        withHeaderMessage
      />
    ) : (
      <LocalizedMessage id="info.bookingStatusDesc" values={{ status: bookingStatus }} />
    );

  const InfoIcon = (
    <AppIcon
      id={icon}
      color={color}
    />
  );

  const WarningIcons = (
    <React.Fragment>
      {entryAndExitForbidden && (
      <div style={{ marginTop: '-6px', marginLeft: '-6px' }}>
        <WarningIcon iconSize="small" tooltipId="tooltip.entryAndExitForbiddenBooking" />
      </div>
      )}
      {!entryAndExitForbidden && booking.restrictedByForbiddenExit && (
      <div style={{ marginTop: '-6px', marginLeft: '-6px' }}>
        <WarningIcon iconSize="small" tooltipId="tooltip.exitForbiddenBooking" />
      </div>
      )}
      {!entryAndExitForbidden && booking.restrictedByForbiddenEntry && (
      <div style={{ marginTop: '-6px', marginLeft: '-6px' }}>
        <WarningIcon iconSize="small" tooltipId="tooltip.entryForbiddenBooking" />
      </div>
      )}
    </React.Fragment>
  );

  /* ========================================================= */
  /* UI                                                        */
  /* ========================================================= */

  return (
    <div className="d-flex">
      <Tooltip light={withInfoTooltip} content={TooltipContent}>
        {InfoIcon}
      </Tooltip>
      {WarningIcons}
    </div>
  );
};

/* ========================================================= */
/* PROP TYPES                                                */
/* ========================================================= */

BookingStatusInfoIcon.propTypes = {
  booking: cpmBookingDataShape.isRequired,
  timezone: PropTypes.string.isRequired,
  withInfoTooltip: PropTypes.bool,
};

/* ========================================================= */
/* DEFAULT PROPS                                             */
/* ========================================================= */

BookingStatusInfoIcon.defaultProps = {
  withInfoTooltip: false,
};

/* ========================================================= */
/* REDUX                                                     */
/* ========================================================= */

const mapStateToProps = (state) => ({
  parkingCategories: state.cpmCarparkParkingCategory.list.elements,
  plannings: state.cpmCarparkPlanning.list.elements,
});

/* ========================================================= */
/* EXPORT                                                        */
/* ========================================================= */

module.exports = connect(
  mapStateToProps,
)(BookingStatusInfoIcon);



// WEBPACK FOOTER //
// ./routes/cpm/routes/carparks/assets/bookings/BookingStatusInfoIcon.js